import { SupportedCurrencyCode } from '../Types/generated-types'

export const isCurrency = (currency?: string | null): currency is SupportedCurrencyCode =>
  !!currency && (Object.values(SupportedCurrencyCode) as string[]).includes(currency)

export const CURRENCY_SYMBOLS: Record<SupportedCurrencyCode, string> = {
  [SupportedCurrencyCode.Gbp]: '£',
  [SupportedCurrencyCode.Eur]: '€',
  [SupportedCurrencyCode.Usd]: '$',
  [SupportedCurrencyCode.Aud]: 'A$',
  [SupportedCurrencyCode.Idr]: 'Rp',
  [SupportedCurrencyCode.Nzd]: 'NZ$',
  [SupportedCurrencyCode.Php]: '₱',
  [SupportedCurrencyCode.Sgd]: 'S$',
  [SupportedCurrencyCode.Hkd]: 'HK$',
  [SupportedCurrencyCode.Thb]: '฿',
  [SupportedCurrencyCode.Jpy]: '¥',
}
